import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { ColorRing } from 'react-loader-spinner';
import { Col } from 'react-bootstrap';
import { postFileRequest, deleteRequest } from '../../requestUtils';
import allActions from '../../actions';
import uploadWhite from '../../../assets/images/upload-white.svg';
import { analyticsTrack } from '../../analyticsUtils';
import './DocumentUpload.scss';
var profileSuggestions = allActions.profileSuggestions;
var renderFileName = function renderFileName(document) {
  if (document) {
    return document.document_file_name;
  }
  return null;
};
var renderSpinner = function renderSpinner(height, width) {
  return /*#__PURE__*/React.createElement(ColorRing, {
    visible: true,
    height: height,
    width: width,
    ariaLabel: "blocks-loading",
    wrapperStyle: {},
    wrapperClass: "updating-icon",
    colors: Array(5).fill('#FFFFFF')
  });
};
var uploadingText = function uploadingText(documentType) {
  switch (documentType) {
    case 'resume':
    case 'parsedResume':
      return 'Loading Resume';
    case 'invoice':
      return 'Uploading Receipt';
    case 'job_description':
      return 'Uploading Job Description';
    default:
      return 'Uploading File';
  }
};
var DocumentUpload = /*#__PURE__*/function (_Component) {
  function DocumentUpload(props) {
    var _this;
    _classCallCheck(this, DocumentUpload);
    _this = _callSuper(this, DocumentUpload, [props]);
    _this.state = {
      uploading: false,
      document: props.document,
      finishedUploading: false,
      errorMessage: null,
      fileError: false
    };
    _this.uploadResume = _this.uploadResume.bind(_this);
    _this.onUploadDocument = _this.onUploadDocument.bind(_this);
    _this.onUpdateDocument = _this.onUpdateDocument.bind(_this);
    _this.onResumeDrop = _this.onResumeDrop.bind(_this);
    _this.removeDocument = _this.removeDocument.bind(_this);
    _this.renderButtonActions = _this.renderButtonActions.bind(_this);
    _this.renderUploadIcon = _this.renderUploadIcon.bind(_this);
    return _this;
  }
  _inherits(DocumentUpload, _Component);
  return _createClass(DocumentUpload, [{
    key: "onResumeDrop",
    value: function onResumeDrop(accepted) {
      this.setState({
        uploading: true
      });
      this.uploadResume(accepted[0]);
    }
  }, {
    key: "onUploadDocument",
    value: function onUploadDocument(prompt) {
      var _this$props = this.props,
        location = _this$props.location,
        userId = _this$props.userId;
      analyticsTrack("Clicked on Add ".concat(prompt), {
        location: location,
        userId: userId
      });
      this.dropzoneRef.open();
    }
  }, {
    key: "onUpdateDocument",
    value: function onUpdateDocument(prompt) {
      var _this$props2 = this.props,
        onboardingQuestionnaire = _this$props2.onboardingQuestionnaire,
        userId = _this$props2.userId;
      analyticsTrack("Clicked on Update ".concat(prompt), {
        location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Consultant Onboarding',
        userId: userId
      });
      this.dropzoneRef.open();
    }
  }, {
    key: "uploadResume",
    value: function uploadResume(file) {
      var _this2 = this;
      var _this$props3 = this.props,
        uploadDocumentUrl = _this$props3.uploadDocumentUrl,
        csrfToken = _this$props3.csrfToken,
        skipParsing = _this$props3.skipParsing,
        handleNewResume = _this$props3.handleNewResume,
        handleAfterUpload = _this$props3.handleAfterUpload,
        handleMenuUpdate = _this$props3.handleMenuUpdate,
        userId = _this$props3.userId,
        documentType = _this$props3.documentType,
        handleResumeUpload = _this$props3.handleResumeUpload,
        location = _this$props3.location;
      this.setState({
        uploading: true,
        finishedUploading: false,
        errorMessage: null,
        fileError: false
      });
      handleResumeUpload(true);
      analyticsTrack(uploadingText(documentType), {
        location: location,
        userId: userId
      });
      postFileRequest(uploadDocumentUrl, file, csrfToken, skipParsing).then(function (response) {
        if (documentType === 'parsedResume') {
          analyticsTrack('Uploaded Resume', {
            location: 'Onboarding Flow',
            userId: userId
          });
          var parsed = response.data.parsed_resume;
          var emptyResume = parsed === null || !(parsed.education.length || parsed.employments.length || parsed.location || parsed.summary);
          _this2.setState({
            document: response.data.resume,
            finishedUploading: true,
            uploading: false,
            fileError: false,
            errorMessage: emptyResume ? 'We were unable to return suggestions. If you have any questions, please reach out to support@clora.com or chat with us below.' : null
          });
          handleMenuUpdate(true);
          if (!emptyResume) {
            _this2.props.resumeParsed(parsed);
            handleNewResume(true);
          }
          handleAfterUpload(response.data.resume);
        } else if (documentType === 'job_description') {
          analyticsTrack('Uploaded Job Description', {
            location: 'Onboarding Flow',
            userId: userId
          });
          handleAfterUpload(response.data.redirect_url);
        } else {
          var document = response.data.resume || response.data;
          _this2.setState({
            finishedUploading: true,
            uploading: false,
            document: document
          });
          handleAfterUpload(document);
        }
        handleResumeUpload(false);
      }, function (error) {
        _this2.setState({
          document: {
            document_file_name: file.name
          },
          finishedUploading: true,
          uploading: false,
          fileError: true,
          errorMessage: error.message
        });
      });
    }
  }, {
    key: "removeDocument",
    value: function removeDocument() {
      var _this3 = this;
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        handleMenuUpdate = _this$props4.handleMenuUpdate,
        proposalResourceId = _this$props4.proposalResourceId,
        handleNewResume = _this$props4.handleNewResume;
      var document = this.state.document;
      if (document && Object.keys(document).length > 1) {
        var removeDocumentUrl;
        if (proposalResourceId) {
          removeDocumentUrl = "/proposals/".concat(proposalResourceId, "/delete_resume");
        } else {
          removeDocumentUrl = "/resumes/".concat(document.resource_id);
        }
        return deleteRequest(removeDocumentUrl, csrfToken).then(function () {
          _this3.props.reinitializeResume();
          _this3.setState({
            document: null,
            errorMessage: null
          });
          handleMenuUpdate(true);
          handleNewResume(false);
        })["catch"](function () {});
      }
      this.setState({
        document: null,
        errorMessage: null,
        fileError: false
      });
      return null;
    }
  }, {
    key: "renderResumeAction",
    value: function renderResumeAction(document, uploading, finishedUploading, prompt, buttonStyle) {
      var _this4 = this;
      if (document && !uploading) {
        return this.renderUploadIcon();
      }
      if (uploading && !finishedUploading) {
        return /*#__PURE__*/React.createElement("a", {
          role: "button",
          tabIndex: 0,
          className: "link document-upload",
          onClick: function onClick() {
            _this4.dropzoneRef.open();
          }
        }, renderSpinner(30, 30));
      }
      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "".concat(buttonStyle, " document-upload"),
        onClick: function onClick() {
          return _this4.onUploadDocument(prompt);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "medium-weight"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus"
      }), prompt));
    }
  }, {
    key: "renderButtonActions",
    value: function renderButtonActions() {
      var _this5 = this;
      var uploading = this.state.uploading;
      var _this$props5 = this.props,
        prompt = _this$props5.prompt,
        documentType = _this$props5.documentType;
      if (uploading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "uploading-container"
        }, renderSpinner(50, 60), /*#__PURE__*/React.createElement("a", {
          role: "button",
          tabIndex: 0,
          className: "btn btn-primary",
          onClick: function onClick() {
            return _this5.onUploadDocument(prompt);
          }
        }, "".concat(uploadingText(documentType), "...")));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "upload-button-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "document-icon"
      }, this.renderUploadIcon()), /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this5.onUploadDocument(prompt);
        }
      }, prompt));
    }
  }, {
    key: "renderUploadIcon",
    value: function renderUploadIcon() {
      var _this6 = this;
      var fileError = this.state.fileError;
      var prompt = this.props.prompt;
      return /*#__PURE__*/React.createElement("button", {
        tabIndex: 0,
        className: "".concat(fileError ? 'update-document-error' : 'update-document'),
        onClick: function onClick() {
          return _this6.onUpdateDocument(prompt);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: uploadWhite,
        alt: "upload-document-icon"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$state = this.state,
        finishedUploading = _this$state.finishedUploading,
        uploading = _this$state.uploading,
        document = _this$state.document,
        errorMessage = _this$state.errorMessage,
        fileError = _this$state.fileError;
      var _this$props6 = this.props,
        viewDocumentUrl = _this$props6.viewDocumentUrl,
        prompt = _this$props6.prompt,
        buttonStyle = _this$props6.buttonStyle,
        documentType = _this$props6.documentType;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Col, {
        className: "ps-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "document-upload new-design"
      }, /*#__PURE__*/React.createElement(Dropzone, {
        ref: function ref(node) {
          _this7.dropzoneRef = node;
        },
        className: "document-dropzone",
        name: "document-upload",
        multiple: false,
        onDrop: this.onResumeDrop
      }), /*#__PURE__*/React.createElement("div", {
        className: "mb-32"
      }, document ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(document && 'g-row--always g-row--between', " ").concat(fileError ? 'file-name-error' : 'file-name')
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(fileError ? 'document-icon-error' : 'document-icon')
      }, this.renderResumeAction(document, uploading, finishedUploading, prompt, "".concat(buttonStyle, " ").concat(buttonStyle === 'button' && 'btn btn-primary'))), /*#__PURE__*/React.createElement("a", {
        className: "body-text-2 document-name",
        href: viewDocumentUrl,
        target: "_blank",
        rel: "noreferrer"
      }, renderFileName(document)), (documentType === 'resume' || documentType === 'parsedResume') && /*#__PURE__*/React.createElement("button", {
        className: "".concat(fileError ? 'remove-document-error' : 'remove-document'),
        onClick: this.removeDocument
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-trash-alt"
      }))), /*#__PURE__*/React.createElement("p", {
        className: "document-upload-text mt-2 fst-italic"
      }, document !== null && document !== void 0 && document.created_at ? "Uploaded on: ".concat(new Date(document.created_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })) : null)) : this.renderButtonActions()))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
        className: "mt-8 ".concat(errorMessage && fileError && 'error-message')
      }, errorMessage && !fileError && /*#__PURE__*/React.createElement("i", {
        className: "me-3 fas fa-exclamation-triangle"
      }), errorMessage)));
    }
  }]);
}(Component);
DocumentUpload.propTypes = {
  document: PropTypes.shape({}),
  proposalResourceId: PropTypes.string,
  prompt: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  viewDocumentUrl: PropTypes.string,
  uploadDocumentUrl: PropTypes.string,
  csrfToken: PropTypes.string,
  buttonStyle: PropTypes.string,
  resumeParsed: PropTypes.func,
  reinitializeResume: PropTypes.func,
  handleMenuUpdate: PropTypes.func,
  handleAfterUpload: PropTypes.func,
  userId: PropTypes.string,
  documentType: PropTypes.oneOf(['resume', 'parsedResume', 'invoice', 'job_description']),
  handleNewResume: PropTypes.func,
  handleResumeUpload: PropTypes.func,
  skipParsing: PropTypes.bool,
  location: PropTypes.string.isRequired,
  onboardingQuestionnaire: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
DocumentUpload.defaultProps = {
  document: null,
  proposalResourceId: null,
  prompt: 'Add File',
  buttonStyle: 'link',
  viewDocumentUrl: null,
  uploadDocumentUrl: '',
  csrfToken: '',
  userId: '',
  documentType: '',
  handleAfterUpload: function handleAfterUpload() {},
  handleMenuUpdate: function handleMenuUpdate() {},
  handleNewResume: function handleNewResume() {},
  handleResumeUpload: function handleResumeUpload() {},
  reinitializeResume: function reinitializeResume() {},
  resumeParsed: function resumeParsed() {},
  skipParsing: false,
  onboardingQuestionnaire: false
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resumeParsed: function resumeParsed(data) {
      return dispatch(profileSuggestions.resumeParsed(data));
    },
    reinitializeResume: function reinitializeResume() {
      return dispatch(profileSuggestions.reinitializeResume());
    }
  };
};
export default connect(null, mapDispatchToProps)(DocumentUpload);